var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0034 12.9573C14.732 12.9573 12.8999 14.7608 12.8999 16.9968C12.8999 19.2327 14.732 21.0362 17.0034 21.0362C19.2749 21.0362 21.107 19.2327 21.107 16.9968C21.107 14.7608 19.2749 12.9573 17.0034 12.9573ZM17.0034 19.6229C15.5356 19.6229 14.3356 18.4452 14.3356 16.9968C14.3356 15.5483 15.532 14.3706 17.0034 14.3706C18.4749 14.3706 19.6713 15.5483 19.6713 16.9968C19.6713 18.4452 18.4713 19.6229 17.0034 19.6229ZM22.232 12.7921C22.232 13.3159 21.8034 13.7343 21.2749 13.7343C20.7427 13.7343 20.3177 13.3124 20.3177 12.7921C20.3177 12.2718 20.7463 11.8499 21.2749 11.8499C21.8034 11.8499 22.232 12.2718 22.232 12.7921ZM24.9499 13.7483C24.8891 12.4862 24.5963 11.3683 23.657 10.4472C22.7213 9.52607 21.5856 9.23779 20.3034 9.17451C18.982 9.10068 15.0213 9.10068 13.6999 9.17451C12.4213 9.23428 11.2856 9.52256 10.3463 10.4437C9.40701 11.3647 9.11773 12.4827 9.05344 13.7448C8.97844 15.0456 8.97844 18.9444 9.05344 20.2452C9.11416 21.5073 9.40701 22.6253 10.3463 23.5464C11.2856 24.4675 12.4177 24.7558 13.6999 24.819C15.0213 24.8929 18.982 24.8929 20.3034 24.819C21.5856 24.7593 22.7213 24.471 23.657 23.5464C24.5927 22.6253 24.8856 21.5073 24.9499 20.2452C25.0249 18.9444 25.0249 15.0491 24.9499 13.7483ZM23.2427 21.6409C22.9641 22.33 22.4249 22.8608 21.7213 23.1386C20.6677 23.5499 18.1677 23.455 17.0034 23.455C15.8392 23.455 13.3356 23.5464 12.2856 23.1386C11.5856 22.8643 11.0463 22.3335 10.7642 21.6409C10.3463 20.6038 10.4427 18.1429 10.4427 16.9968C10.4427 15.8507 10.3499 13.3862 10.7642 12.3526C11.0427 11.6636 11.582 11.1327 12.2856 10.855C13.3392 10.4437 15.8392 10.5386 17.0034 10.5386C18.1677 10.5386 20.6713 10.4472 21.7213 10.855C22.4213 11.1292 22.9606 11.6601 23.2427 12.3526C23.6606 13.3897 23.5641 15.8507 23.5641 16.9968C23.5641 18.1429 23.6606 20.6073 23.2427 21.6409Z",
    fill: "#192031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white",
    transform: "translate(9.00012 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.10a1f138916b9c62a5ace6c202534438.svg";
export { ForwardRef as ReactComponent };